import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'coach/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('coach/', '')
      .toLowerCase();
  }
}
